<template>
  <v-container fluid class="pa-0">

    <Titulo></Titulo>

    <br v-if="screen <= 800">

    <v-stepper v-model="e1" elevation="0" :class="Vstep">
      <div :class="Vflex">
        <NavBar :step="1"></NavBar>
        <v-stepper-header>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Plan
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step2">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step2">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" step="5"> Datos </v-stepper-step>
          </div>
        </v-stepper-header>
      </div>

      <v-stepper-items>
        <v-stepper-content step="2">

          <div class="formData">

          </div>

          <br>

          <div v-if="planData.setDesc" :class="labeltextDesc">
            <label class="descText"> &nbsp;&nbsp; ¡Descuento del {{ this.planData.valueDesc }}% aplicado!</label>
          </div>

          <br v-if="invalidCoupon">
          <div v-if="invalidCoupon" :class="labeltextInvalid">
            <label class="descTextInvalid"> &nbsp;&nbsp; Cupón inválido</label>
          </div>

          <div v-if="screen > 800 && plans.length != 0" class="planContainer">
            <PlanEscritorio :planData="plans" :planDataAux="planData" :index="indice" :plansOutDesc="plansOutDesc"
              :userData="userData" :benefData="benefData" :servicesData="servicesData" :loadingPlans="loadingPlans"
              @next-step="validate" />
          </div>

          <div v-if="screen <= 800 && plans.length != 0" class="planContainer">
            <PlanMovil :planData="plans" :planDataAux="planData" :index="indice" :plansOutDesc="plansOutDesc"
              :userData="userData" :benefData="benefData" :servicesData="servicesData" :loadingPlans="loadingPlans"
              @next-step="validate" />
          </div>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import PlanEscritorio from "@/components/PlanEscritorio.vue";
import PlanMovil from "@/components/PlanMovil.vue";
import ShieldService from "../services/shield.service";
import Titulo from "../components/Titulo.vue";
import NavBar from "@/components/NavBar.vue";

import iconCoupon from "../assets/images/couponImage.svg";

import CryptoJS from 'crypto-js';

export default {
  name: "PlanForm",
  components: { PlanEscritorio, PlanMovil, Titulo, NavBar },
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    iconCoupon,
    invalidCoupon: false,
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      typeIsapre: null,
      region: null,
      commune: null,
      comuneCode: null,
      regionCode: null,
      address: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      stepId: null,
      old: null,
      dates: null,
      salud: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
      typePlan: null,
      addressNumber: null,
      addressDepto: null,
      sonExist: false,
      arrayTypesBenef: [],
      oldAux: null,
      day: null,
      month: null,
      year: null,
    },
    benefData: [
      {
        tab: '',
        validRut: false,
        tipo: null,
        edad: null,
        name: '',
        surname: '',
        rut: '',
        days: ['Selecciona el mes'],
        months: null,
        years: null,
        date: null,
        newRut: '',
        panel: 0,
        year: null,
        month: null,
        day: null,
      }
    ],
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'update',
    },
    planData: {
      planOutDesc: null,
      setDesc: false,
      valueDesc: 0,
      couponId: null,
      plan: null,
    },
    plans: [],
    plansOutDesc: [],
    stepperColor: '#4F74E3',
    e1: 2,
    loadingPlans: true,
    labelDescuento: '',
    Vstep: '',
    Vflex: '',
    couponRules: [
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres",
      (v) => !!v || 'El código de descuento es requerido.',
      (v) => (v && !/\s/.test(v)) || 'El código de descuento no puede contener espacios en blanco.'
    ],
    screen: window.screen.width,
  }),
  async mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.body.setAttribute('data-sku', 'ONC-002-PLN');

    const query = this.$route.query;

    const userDataAux = sessionStorage.getItem('userData');
    const servicesDataAux = sessionStorage.getItem('servicesData');
    const planDataAux = sessionStorage.getItem('planData');
    const benefDataAux = sessionStorage.getItem('benefData');

    if (query.stepID) {

      const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

      this.userData = abandoned.userData;
      this.planData = abandoned.planData;
      this.servicesData.stepId = abandoned._id;
      this.servicesData.type = 'update';
      if (this.planData.plan.cantBenf.includes('familiar')) {
        this.benefData = abandoned.benefData;
      }

      const userDataLocal = JSON.stringify(this.userData);
      const servicesDataLocal = JSON.stringify(this.servicesData);
      const planDataLocal = JSON.stringify(this.planData);
      const benefDataLocal = JSON.stringify(this.benefData);

      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      const encryptedBenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();

      sessionStorage.setItem('userData', encryptedUserDataLocal);
      sessionStorage.setItem('servicesData', encryptedServicesDataLocal);
      sessionStorage.setItem('planData', encryptedPlanDataLocal);
      sessionStorage.setItem('benefData', encryptedBenefDataLocal);

    } else if (userDataAux) {

      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);

      const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
      const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
      this.servicesData = JSON.parse(decryptedServicesData);
      // console.log("servicesData: ", this.servicesData);

      if (planDataAux) {
        const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
        const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
        this.planData = JSON.parse(decryptedDataPlan);
        // console.log("planData: ", this.planData);

      } else {
        const planDataLocal = JSON.stringify(this.planData);
        const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
        sessionStorage.setItem('planData', encryptedPlanDataLocal);
      }

      if (benefDataAux) {
        const bytesBenefData = CryptoJS.AES.decrypt(benefDataAux, this.secretKey);
        const decryptedDatabenef = bytesBenefData.toString(CryptoJS.enc.Utf8);
        this.benefData = JSON.parse(decryptedDatabenef);
        // console.log("userData: ", this.benefData);
      }

    }

    if (this.screen > 800) {
      this.labelDescuento = 'labelDescuento'
      this.labeltextDesc = 'descLabel'
      this.labeltextInvalid = 'invalidLabel'
      this.Vstep = 'VstepDesktop';
      this.Vflex = 'VflexDesktop';
    } else {
      this.labelDescuento = 'labelDescuento2'
      this.labeltextDesc = 'descLabelMovil'
      this.labeltextInvalid = 'invalidLabelMovil'
      this.Vflex = 'VflexMobile';
    }

    this.getPlans();
  },
  methods: {
    deteleSpace() {
      this.planData.couponId = this.planData.couponId.replace(/\s/g, '');
    },
    back() {
      this.$router.push({ path: '/og/' })
    },
    validate(plan) {
      this.$emit("next-step", 2, plan);
    },
    async getPlans() {
      this.loadingPlans = true;

      let planIndividual = await ShieldService.getPlans(this.userData.old.name, 'individual', this.planData.couponId);
      let planFamiliar = await ShieldService.getPlans(this.userData.old.name, 'familiar', this.planData.couponId);

      this.plans.push(planIndividual[0], planFamiliar[0]);

      // this.planData.plan = this.plans[0];
      if (!this.planData.plan) {
        this.planData.plan = this.plans[0];
      }

      this.loadingPlans = false;

    },
    capitalizeName(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
  },
};
</script>


<style lang="scss">
.VflexDesktop {
  background-color: rgb(247, 247, 247);
  display: flex;
  margin: auto;
  height: 50px;
}

.VflexMobile {
  background-color: rgb(247, 247, 247);
  display: flex;
  margin: auto;
  height: 30px;
  margin-top: -2.3%;
  margin-bottom: 2.3%
}

.VstepDesktop {
  margin-top: -0.3%
}

.descLabel {
  background-color: #F6F6FE;
  width: 223px;
  height: 25px;
  margin: auto;
}

.descLabelMovil {
  background-color: #F6F6FE;
  width: 223px;
  height: 25px;
  margin: auto;
}

.invalidLabel {
  background-color: #FFF0F0;
  width: 223px;
  height: 25px;
  margin: auto;
}

.invalidLabelMovil {
  background-color: #FFF0F0;
  width: 223px;
  height: 25px;
  margin: auto;
}

.descText {
  width: 266px;
  height: 33px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #4F74E3;
}

.descTextInvalid {
  width: 266px;
  height: 33px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  padding-left: 20%;
  padding-right: 20%;
  color: #C33025;
}

.labelTituloo {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
}

.labelSubtitulo {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  padding: 2%;
}

.botonAplicar {
  border-radius: 0px 10px 10px 0px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 143.34%;
  text-transform: capitalize;
}

.labelDescuento {
  width: 320px;
  height: 48px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 10px 0 0 10px;
  margin: auto;
}

.labelDescuento2 {
  min-width: 30%;
  max-width: 62%;
  height: 48px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 10px 0 0 10px;
  margin: auto;
}

.planContainer {
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.formData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tienesCupon {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background: #ECF0FC;
  border-radius: 4px;
  // padding-right: 2%;
  // margin-top: 2%;
  padding-left: 2%;
}

.tienesCuponText {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #2D387C;
  margin: auto;
  margin-top: 4%;
  width: 85ca7 !important;
}
</style>